module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-hyundai.d4606ee8.png";